/**
 * Freeze component — overrides the timeline context to freeze at a specific frame.
 * Used by premounted sequences to keep children at a stable frame while hidden.
 *
 * Written from scratch for Steve.AI.
 */

import React, { useContext, useMemo } from 'react';
import { SequenceContext } from '../SequenceContext';
import { TimelineContext } from '../timeline-position-state';

export const Freeze = ({ frame, children, active = true }) => {
  if (typeof frame === 'undefined') {
    throw new Error('<Freeze /> requires a "frame" prop.');
  }
  if (typeof frame !== 'number' || Number.isNaN(frame) || !Number.isFinite(frame)) {
    throw new Error(`<Freeze /> "frame" must be a finite number, got: ${frame}`);
  }

  const context = useContext(TimelineContext);

  const frozenContext = useMemo(() => {
    if (!active) return context;
    return {
      ...context,
      playing: false,
      imperativePlaying: { current: false },
      frame,
    };
  }, [context, frame, active]);

  return (
    <TimelineContext.Provider value={frozenContext}>
      <SequenceContext.Provider value={null}>
        {children}
      </SequenceContext.Provider>
    </TimelineContext.Provider>
  );
};
